import { defineRecipe } from "@chakra-ui/react";

// Shared with `IconButton`. Restores the Chakra v2 button look.
const buttonRecipe = defineRecipe({
  base: {
    height: "40px",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    borderWidth: "0",
    borderRadius: "md",
  },
  variants: {
    size: {
      md: {
        textStyle: "md",
        px: "4",
      },
    },
    variant: {
      primary: {
        backgroundColor: "brand.primary",
        color: "brand.white",
        _disabled: {
          backgroundColor: "brand.disabledBtnBg",
          opacity: 1,
        },
        _hover: {
          backgroundColor: "brand.primary",
          _disabled: {
            backgroundColor: "brand.disabledBtnBg",
          },
        },
      },
      outline: {
        backgroundColor: "transparent",
        borderWidth: "2px",
        borderColor: "brand.primary",
        color: "brand.primary",
        _disabled: {
          opacity: 0.6,
        },
        _hover: {
          backgroundColor: "transparent",
        },
        _active: {
          backgroundColor: "transparent",
        },
      },
      ghost: {
        backgroundColor: "transparent",
        color: "brand.primary",
        _disabled: {
          opacity: 0.6,
        },
        _hover: {
          backgroundColor: "transparent",
        },
        _active: {
          backgroundColor: "transparent",
        },
      },
      secondary: {
        backgroundColor: "grey.5",
        color: "brand.chatMessageText",
        _disabled: {
          opacity: 0.6,
        },
        _hover: {
          backgroundColor: "transparent",
        },
        _active: {
          backgroundColor: "transparent",
        },
      },
      neutral: {
        backgroundColor: "brand.white",
        borderWidth: "1px",
        borderColor: "gray.200",
        color: "brand.modalHeaderText",
        _disabled: {
          opacity: 0.6,
        },
        _hover: {
          backgroundColor: "brand.bg",
        },
      },
      // Unstyled, as the undefined v2 variant rendered.
      cancel: {
        backgroundColor: "transparent",
        color: "inherit",
        _disabled: {
          opacity: 0.6,
        },
      },
      link: {
        backgroundColor: "transparent",
        color: "brand.primary",
        height: "auto",
        minW: "auto",
        padding: 0,
        lineHeight: "normal",
        verticalAlign: "baseline",
        _hover: {
          backgroundColor: "transparent",
          textDecoration: "underline",
        },
      },
      // Default variant: v2's gray `solid`.
      gray: {
        backgroundColor: "gray.100",
        color: "#1A202C",
        _hover: {
          backgroundColor: "gray.200",
        },
        _active: {
          backgroundColor: "#CBD5E0",
        },
        _disabled: {
          opacity: 0.4,
        },
      },
      transparent: {
        bg: "transparent",
        _hover: {
          bg: "transparent",
        },
      },
    },
  },
  defaultVariants: {
    variant: "gray",
  },
});

export default buttonRecipe;
